import { render } from "./NItemsList.vue?vue&type=template&id=28e225c0&scoped=true"
import script from "./NItemsList.vue?vue&type=script&lang=js"
export * from "./NItemsList.vue?vue&type=script&lang=js"

import "./NItemsList.vue?vue&type=style&index=0&id=28e225c0&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e225c0"]])

export default __exports__